import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { MobileHeaderBar } from "./MobileHeaderBar";
import { AppSidebar } from "../sidebar/AppSiderbar";
import { AppMainContent } from "./AppMainContent";

const DEFAULT_DRAWER_WIDTH = 260;
const MINI_DRAWER_WIDTH = 72;

export const RootLayout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (!isMobile && mobileOpen) setMobileOpen(false);
  }, [isMobile, mobileOpen]);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {isMobile && (
        <MobileHeaderBar onMenuOpen={() => setMobileOpen((prev) => !prev)} />
      )}
      <AppSidebar
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen((prev) => !prev)}
        collapsed={collapsed}
        onCollapse={setCollapsed}
        defaultDrawerWidth={DEFAULT_DRAWER_WIDTH}
        miniDrawerWidth={MINI_DRAWER_WIDTH}
        onMenuItemClick={() => setMobileOpen(false)}
      />
      <AppMainContent />
    </Box>
  );
};
